module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/addAnnouncement'
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_vm._v("新增公告")])]), _vm._v(" "), (!_vm.isDeleteStatus) ? _c('div', {
    staticClass: "btn btn-default btn-table-title",
    on: {
      "click": function($event) {
        _vm.isDeleteStatus = true
      }
    }
  }, [_vm._v("批次刪除")]) : _vm._e(), _vm._v(" "), (_vm.isDeleteStatus) ? _c('div', {
    staticClass: "btn btn-default btn-table-title",
    on: {
      "click": function($event) {
        _vm.isDeleteStatus = false
      }
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), (_vm.isDeleteStatus) ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delNewsModal"
    },
    on: {
      "click": _vm.deleteAnnouncement
    }
  }, [_vm._v("刪除")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [(_vm.isDeleteStatus) ? _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }) : _vm._e(), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("序號")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("標題")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("蓋板公告")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("發布對象")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("發布時間")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("最後編輯時機")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("最後編輯編輯者")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  })])]), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(0)]) : (!_vm.isLoading && _vm.announcementList.length > 0) ? _c('tbody', _vm._l((_vm.announcementList), function(news, index) {
    return _c('tr', {
      key: index,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [(_vm.isDeleteStatus) ? _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (news.selectItem),
        expression: "news.selectItem"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(news.selectItem) ? _vm._i(news.selectItem, null) > -1 : (news.selectItem)
      },
      on: {
        "change": function($event) {
          var $$a = news.selectItem,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(news, "selectItem", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(news, "selectItem", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(news, "selectItem", $$c)
          }
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "sorting_1"
    }, [_vm._v("\n                              " + _vm._s(index + 1) + "\n                          ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "200px"
      }
    }, [_vm._v("\n                              " + _vm._s(news.title) + "\n                          ")]), _vm._v(" "), _c('td', [_c('span', {
      class: ['label', news.is_overlay ? 'label-success' : 'label label-danger']
    }, [_vm._v(_vm._s(news.is_overlay ? '啟用' : '不啟用'))])]), _vm._v(" "), _c('td', [_vm._v("\n                              " + _vm._s(_vm._f("roleType")(news.role_type)) + "\n                          ")]), _vm._v(" "), _c('td', [_vm._v("\n                              " + _vm._s(news.announce_time) + "\n                          ")]), _vm._v(" "), _c('td', [_vm._v("\n                              " + _vm._s(news.update_time) + "\n                          ")]), _vm._v(" "), _c('td', [_vm._v("\n                              " + _vm._s(news.user_account) + "\n                          ")]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/editAnnouncement/' + news.announcement_id
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-default"
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#delNewsModal"
      },
      on: {
        "click": function($event) {
          return _vm.deleteSingleAnnouncement(news.announcement_id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1)])
  }), 0) : (!_vm.isLoading && _vm.announcementList.length === 0) ? _c('tbody', [_vm._m(1)]) : _vm._e()])]), _vm._v(" "), _c('paginate', {
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1)]), _vm._v(" "), _c('m-modal', {
    attrs: {
      "option": _vm.delDesAlisOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "12"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79b23f77"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Announcement/index.vue
// module id = 2490
// module chunks = 1